import { QueryCache, MutationCache, QueryKey } from "react-query";
import { Sentry } from "./sentry";

/**
 * QueryCache global con onError que reporta a Sentry. Captura el error real
 * (no el wrapped del axios interceptor) con el nombre del recurso como tag de
 * baja cardinalidad para que Sentry agrupe bien.
 *
 * No incluye variables ni response body por default — los hooks que quieran
 * agregar contexto pueden hacerlo vía `meta` en el useQuery.
 */
export function createSentryQueryCache(): QueryCache {
  return new QueryCache({
    onError: (error, query) => {
      Sentry.captureException(error, {
        tags: {
          source: "react-query",
          query_resource: keyResource(query.queryKey),
        },
        extra: {
          queryKey: query.queryKey,
          queryHash: query.queryHash,
          meta: query.meta,
        },
      });
    },
  });
}

export function createSentryMutationCache(): MutationCache {
  return new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      Sentry.captureException(error, {
        tags: {
          source: "react-query-mutation",
          mutation_resource: keyResource(mutation.options.mutationKey),
        },
        extra: {
          mutationKey: mutation.options.mutationKey,
          meta: mutation.meta,
        },
      });
    },
  });
}

/**
 * Devuelve el primer segmento string del key (p.ej. "products" en
 * `["products", { warehouseId }]`). Mantiene el tag con cardinalidad baja
 * para que Sentry pueda filtrar/agrupar.
 */
function keyResource(key: QueryKey | undefined): string {
  if (key == null) return "unknown";
  if (typeof key === "string") return key;
  if (Array.isArray(key) && key.length > 0 && typeof key[0] === "string") {
    return key[0];
  }
  return "unknown";
}
